import {createContext} from "react";
import GoodsViewModel from "@contents/viewModels/goodsViewModel";
import GoodsDisplayViewModel from "@contents/viewModels/goodsDisplayViewModel";
import GoodsOptionViewModel from "@contents/viewModels/goodsOptionViewModel";
import GoodsStockViewModel from "@contents/viewModels/goodsStockViewModel";
import MealViewModel from "@contents/viewModels/mealViewModel";

import SurveyViewModel from "@contents/viewModels/surveyViewModel";
import DeviceViewModel from "@contents/viewModels/deviceViewModel";
import BoardViewModel from "@contents/viewModels/boardViewModel";
import MemberViewModel from "@contents/viewModels/memberViewModel";
import ShopSalesPlanViewModel from "@contents/viewModels/shopSalesPlanViewModel";
import {ShopViewModel} from "@contents/viewModels/shopViewModel";
import DeliveryViewModel from "@contents/viewModels/deliveryViewModel";
import SatisfactionViewModel from "@contents/viewModels/satisfactionViewModel";
import StorageViewModel from "@contents/viewModels/storageViewModel";
import DistributeViewModel from "@contents/viewModels/distributeViewModel";
import StatisticsViewModel from "@contents/viewModels/statisticsViewModel";
import ContentViewModel from "@contents/viewModels/contentViewModel";
import {DashboardViewModel} from "@contents/viewModels/dashboardViewModel";
import CustomerViewModel from "@contents/viewModels/customerViewModel";
import GoodsCategoryViewModel from "@contents/viewModels/goodsCategoryViewModel";
import GoodsGroupViewModel from "@contents/viewModels/goodsGroupViewModel";
import MealOperationTimeViewModel from "@contents/viewModels/mealOperationTimeViewModel";
import MealCourseViewModel from "@contents/viewModels/mealCourseViewModel";
import {AppViewModel} from "@contents/viewModels/appViewModel";
import BrandViewModel from "@contents/viewModels/brandViewModel";
import PointViewModel from "@contents/viewModels/pointViewModel";
import StatisticsBrandViewModel from "@contents/viewModels/statisticsBrandViewModel";

export const DeviceInfoDetailContext = createContext<ReturnType<typeof DeviceViewModel> | undefined>(undefined);

export type ProductDisplayDetailContextType = {
    goodsDisplayView: ReturnType<typeof GoodsDisplayViewModel> | undefined;
    categoryView: ReturnType<typeof GoodsCategoryViewModel> | undefined;
}
export const ProductDisplayDetailContext = createContext<ProductDisplayDetailContextType>({
    goodsDisplayView: undefined,
    categoryView: undefined
});
export type ProductContentEditContextType = {
    goodsView: ReturnType<typeof GoodsViewModel> | undefined;
    stockView: ReturnType<typeof GoodsStockViewModel> | undefined;
}
export const ProductContentEditContext = createContext<ProductContentEditContextType>({
    goodsView: undefined,
    stockView: undefined
});
export const ProductCategoryContext = createContext<ReturnType<typeof GoodsCategoryViewModel> | undefined>(undefined);
export const ProductGroupContext = createContext<ReturnType<typeof GoodsGroupViewModel> | undefined>(undefined);
export const ProductContentOptionContext = createContext<ReturnType<typeof GoodsOptionViewModel> | undefined>(undefined);
export const ProductContentStockContext = createContext<ReturnType<typeof GoodsStockViewModel> | undefined>(undefined);

export const MealContentContext = createContext<ReturnType<typeof MealViewModel> | undefined>(undefined);
export const MealCourseContext = createContext<ReturnType<typeof MealCourseViewModel> | undefined>(undefined);
export const MealOperationTimeContext = createContext<ReturnType<typeof MealOperationTimeViewModel> | undefined>(undefined);

export const BrandSurveyEditContext = createContext<ReturnType<typeof SurveyViewModel> | undefined>(undefined);
export const BoardEditContext = createContext<ReturnType<typeof BoardViewModel> | undefined>(undefined);

export const MemberContext = createContext<ReturnType<typeof MemberViewModel> | undefined>(undefined);

export const SalesPlanContext = createContext<ReturnType<typeof ShopSalesPlanViewModel> | undefined>(undefined);

export const ShopContext = createContext<ReturnType<typeof ShopViewModel> | undefined>(undefined);

export const DeliveryContext = createContext<ReturnType<typeof DeliveryViewModel> | undefined>(undefined);

export const SatisfactionContext = createContext<ReturnType<typeof SatisfactionViewModel> | undefined>(undefined);

export const StorageContext = createContext<ReturnType<typeof StorageViewModel> | undefined>(undefined);

export const DistributeContext = createContext<ReturnType<typeof DistributeViewModel> | undefined>(undefined);

export const StatisticsContext = createContext<ReturnType<typeof StatisticsViewModel> | undefined>(undefined);

export const BrandStatisticsContext = createContext<ReturnType<typeof StatisticsBrandViewModel> | undefined>(undefined);

export const ContentContext = createContext<ReturnType<typeof ContentViewModel> | undefined>(undefined);

export const DashboardContext = createContext<ReturnType<typeof DashboardViewModel> | undefined>(undefined);

export const CustomerContext = createContext<ReturnType<typeof CustomerViewModel> | undefined>(undefined);

export const ResponsibleContext = createContext<ReturnType<typeof AppViewModel> | undefined>(undefined);

export const BrandContext = createContext<ReturnType<typeof BrandViewModel> | undefined>(undefined);

export const PointContext = createContext<ReturnType<typeof PointViewModel> | undefined>(undefined);

export type PasswordChangeContextType = {
    oldPassword?: string;
    setOldPassword?: (oldPassword: string) => void;
    userId?: string;
}

export const PasswordChangeContext = createContext<PasswordChangeContextType>({
    oldPassword: "",
    setOldPassword: () => {
    },
    userId: "",
});